<template>
    <div :class="[ui.row, config.ui]">
        <div v-for="(col, i) in config.cols" :key="`col_${i}`" :class="col.ui">
            <template v-for="content in col.content" :key="content.id">
                <TextBlock v-if="content.type === 'text'" :config="content"></TextBlock>
                <LinesBlock v-else-if="content.type === 'lines'" :config="content"></LinesBlock>
                <ButtonBlock v-else-if="content.type === 'button'" :config="content"></ButtonBlock>
                <ImageBlock v-else-if="content.type === 'image'" :config="content"></ImageBlock>
                <IconBlock v-else-if="content.type === 'icon'" :config="content"></IconBlock>
                <CardBlock v-else-if="content.type === 'card'" :config="content"></CardBlock>
                <SectionBlock
                    v-else-if="content.type === 'section'"
                    :config="content"
                ></SectionBlock>
            </template>
        </div>
    </div>
</template>

<script setup lang="ts">
import CardBlock from './CardBlock.vue'
import TextBlock from './TextBlock.vue'
import LinesBlock from './LinesBlock.vue'
import ButtonBlock from './ButtonBlock.vue'
import ImageBlock from './ImageBlock.vue'
import IconBlock from './IconBlock.vue'
import SectionBlock from './SectionBlock.vue'
import { useIsDesktop } from '~~/layers/base/composables/useIsDesktop'
import type { RowBlockConfig } from '~~/layers/base/types/blockConfigs'

const props = defineProps<{
    config: RowBlockConfig
}>()

const { isDesktop } = useIsDesktop()

/** Desktop: flex row (like printing process features), alternating via desktopReverse. Mobile: stack (grid-cols-1) when mobileStack, else 2 cols. */
const ui = computed(() => {
    const desktop = isDesktop.value
    const mobileGrid = props.config.mobileStack
        ? 'grid grid-cols-1 gap-5'
        : 'grid grid-cols-2 gap-5'
    return {
        row: [
            desktop
                ? 'flex flex-row gap-6 items-center [&>div]:flex-1 [&>div]:min-w-0'
                : mobileGrid,
            desktop && props.config.desktopReverse ? 'flex-row-reverse' : '',
        ],
    }
})
</script>
